module.exports = __webpack_public_path__ + "fbStatic/fonts/iconfont.6ae1a79a.woff";